export const bounties = [
  {
    rank: 1,
    title: "网络理财平台异常提现线索",
    category: "财经线索",
    amount: 6000,
    deadline: "2026-09-30",
    joiners: 128,
    level: "S 级",
  },
  {
    rank: 2,
    title: "电商平台刷单返现链条追踪",
    category: "网络乱象",
    amount: 5000,
    deadline: "2026-09-28",
    joiners: 112,
    level: "S 级",
  },
  {
    rank: 3,
    title: "直播间保健品宣传用语调查",
    category: "行业黑幕",
    amount: 4000,
    deadline: "2026-09-26",
    joiners: 96,
    level: "A 级",
  },
  {
    rank: 4,
    title: "城郊工业园夜间偷排废水疑云",
    category: "环境安全",
    amount: 3000,
    deadline: "2026-09-24",
    joiners: 74,
    level: "A 级",
  },
  {
    rank: 5,
    title: "老旧小区改造资金使用疑点",
    category: "民生关注",
    amount: 2500,
    deadline: "2026-09-22",
    joiners: 58,
    level: "A 级",
  },
  {
    rank: 6,
    title: "二手车检测报告真实性争议",
    category: "消费维权",
    amount: 2000,
    deadline: "2026-09-20",
    joiners: 45,
    level: "B 级",
  },
  {
    rank: 7,
    title: "某连锁培训机构退费拖延问题",
    category: "教育观察",
    amount: 1500,
    deadline: "2026-09-18",
    joiners: 39,
    level: "B 级",
  },
  {
    rank: 8,
    title: "某企业招聘承诺与合同不符",
    category: "职场内幕",
    amount: 1200,
    deadline: "2026-09-16",
    joiners: 27,
    level: "B 级",
  },
];

export const bountyLevels = [
  {
    level: "S 级",
    range: "5000 元以上",
    desc: "涉及重大公众利益、链条完整、可核实性高的核心线索。",
    icon: "ri-fire-line",
  },
  {
    level: "A 级",
    range: "2000 - 5000 元",
    desc: "指向明确、具备关键证据、能推动议题进一步核实的线索。",
    icon: "ri-flashlight-line",
  },
  {
    level: "B 级",
    range: "1000 - 2000 元",
    desc: "具备参考价值的补充信息，可协助还原事件细节。",
    icon: "ri-information-line",
  },
];